import { type ReactNode } from 'react'

import type { TooltipArrowPosition, TooltipPlacement } from './types'

export function cx(...parts: Array<string | false | null | undefined>): string {
    return parts.filter(Boolean).join(' ')
}

export function hasTooltipContent(content: ReactNode): boolean {
    if (content == null || content === false || content === true) return false
    if (typeof content === 'string' && content.trim() === '') return false
    return true
}

export const ARROW_SIZE = 8
export const ARROW_OFFSET = 8
export const ARROW_PADDING = 12

export const STATIC_SIDE: Record<string, 'top' | 'right' | 'bottom' | 'left'> = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
}

/** Maps arrow-on-bubble position to floating-ui placement of the tooltip. */
export const ARROW_TO_PLACEMENT: Record<TooltipArrowPosition, TooltipPlacement> = {
    bottom: 'top',
    'bottom-left': 'top-start',
    'bottom-right': 'top-end',
    top: 'bottom',
    'top-left': 'bottom-start',
    'top-right': 'bottom-end',
    left: 'right',
    'left-top': 'right-start',
    'left-bottom': 'right-end',
    right: 'left',
    'right-top': 'left-start',
    'right-bottom': 'left-end',
}

export function resolveTooltipPlacement(
    placement: TooltipPlacement,
    arrow?: TooltipArrowPosition
): TooltipPlacement {
    return arrow ? ARROW_TO_PLACEMENT[arrow] : placement
}
